export default __webpack_public_path__ + "static/media/GameCord.c0704fc3.png";